import { ThemeEvents } from '@theme/events';

/**
 * Like variant-scoped-block but extends HTMLElement instead of Component.
 * This keeps the element transparent to product-card's #isDescendant check,
 * so slideshow-component[ref="slideshow"] stays in product-card.refs after
 * innerHTML replacement (prevents hover-image-switch regression).
 */
class CardGalleryBlock extends HTMLElement {
  connectedCallback() {
    const target = this.closest('product-card');
    if (!target) return;
    this.eventTarget = target;
    target.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    this.eventTarget?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const productId = this.dataset.productId;
    if (
      productId &&
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== productId
    ) {
      return;
    }

    const blockId = this.dataset.blockId;
    const fresh = blockId
      ? html.querySelector(`card-gallery-block[data-block-id="${CSS.escape(blockId)}"]`)
      : null;

    if (!fresh) {
      if (this.innerHTML !== '') this.innerHTML = '';
      return;
    }
    if (fresh.innerHTML === this.innerHTML) return;
    this.innerHTML = fresh.innerHTML;
  };
}

if (!customElements.get('card-gallery-block')) {
  customElements.define('card-gallery-block', CardGalleryBlock);
}
